import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15.618 20.243l-2.193 -5.602a3 3 0 1 0 -2.849 0l-2.193 5.603","key":"svg-0"}],["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-1"}]]

const IconBrandOpenvpn = createReactComponent('outline', 'brand-openvpn', 'BrandOpenvpn', __iconNode);

export default IconBrandOpenvpn;